import * as Yup from "yup";

export const progressiveBonusDefaults = {
  quad_of_day_amount: 775,
  four_flushes_amount: 400,
  royal_bonus_amount: 790,
  bad_beat_amount: 1210,
  spades_straight_flush_amount: 50,
  hearts_straight_flush_amount: 50,
  clubs_straight_flush_amount: 50,
  diamonds_straight_flush_amount: 50,
  quad_of_day_rank: "7",
};

export const mainBonusFields = [
  {
    field: "quad_of_day_amount",
    label: "Quad of the Day",
    subtitle: "Must use both hole cards",
    symbol: "♛",
  },
  {
    field: "four_flushes_amount",
    label: "4 Flushes",
    subtitle: "First to win with each suit",
    symbol: "♠",
  },
  {
    field: "royal_bonus_amount",
    label: "Royal Bonus",
    subtitle: "Must use both hole cards",
    symbol: "♛",
  },
  {
    field: "bad_beat_amount",
    label: "Bad Beat",
    subtitle: "Lose with AAAQQ",
    symbol: "♥",
  },
];

export const straightFlushFields = [
  { field: "spades_straight_flush_amount", label: "Spades", symbol: "♠", tone: "black" },
  { field: "hearts_straight_flush_amount", label: "Hearts", symbol: "♥", tone: "red" },
  { field: "clubs_straight_flush_amount", label: "Clubs", symbol: "♣", tone: "black" },
  { field: "diamonds_straight_flush_amount", label: "Diamonds", symbol: "♦", tone: "red" },
];

export const progressiveBonusOverlayLayout = {
  quad_of_day_amount: { left: 61.46, top: 47.24, fontSize: 4.4 },
  four_flushes_amount: { left: 61.85, top: 55.69, fontSize: 4.4 },
  royal_bonus_amount: { left: 61.92, top: 64.81, fontSize: 4.4 },
  bad_beat_amount: { left: 61.84, top: 73.39, fontSize: 4.4 },
  spades_straight_flush_amount: { left: 92.23, top: 62.77, fontSize: 3.6 },
  hearts_straight_flush_amount: { left: 92.23, top: 70.17, fontSize: 3.6 },
  clubs_straight_flush_amount: { left: 92.23, top: 77.69, fontSize: 3.6 },
  diamonds_straight_flush_amount: { left: 92.23, top: 85.19, fontSize: 3.6 },
  quad_of_day_rank: {
    left: 84.63,
    top: 43.4,
    fontSize: 9,
    pendingFontSize: 5,
  },
};

export const quadRanks = ["TBD", "2", "3", "4", "5", "6", "7", "8", "9", "10", "J", "Q", "K", "A"];

const amountValidation = Yup.number()
  .typeError("Enter a valid amount")
  .required("Amount is required")
  .min(0, "Amount cannot be negative")
  .max(99999999.99, "Amount is too large");

export const progressiveBonusValidationSchema = Yup.object({
  quad_of_day_amount: amountValidation,
  four_flushes_amount: amountValidation,
  royal_bonus_amount: amountValidation,
  bad_beat_amount: amountValidation,
  spades_straight_flush_amount: amountValidation,
  hearts_straight_flush_amount: amountValidation,
  clubs_straight_flush_amount: amountValidation,
  diamonds_straight_flush_amount: amountValidation,
  quad_of_day_rank: Yup.string()
    .required("Card rank is required")
    .oneOf(quadRanks, "Select a valid card rank"),
});

export const formatBonusAmount = (amount) => new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: Number(amount) % 1 === 0 ? 0 : 2,
  maximumFractionDigits: 2,
}).format(Number(amount) || 0);
